import mixpanel from 'mixpanel-browser';

const source = 'dashboard:trending_keywords';

const getSentimentNameByNumber = key => {
    const sentiments = {
        0: 'Neutral',
        1: 'Positive',
        '-1': 'Negative'
    };

    return sentiments[key];
};

export default {
    trackClickedKeyword() {
        mixpanel.track(`${source}:keyword_clicked`);
    },

    trackSorting(sortBy) {
        mixpanel.track(`${source}:sort`, {
            'Sort By': sortBy
        });
    },

    trackPageChange(page) {
        mixpanel.track(`${source}:next_page`, {
            Page: page
        });
    },

    trackSentimentClick(value) {
        const sentiment = getSentimentNameByNumber(value);

        mixpanel.track(`${source}:sentiment_clicked`, {
            Sentiment: sentiment
        });
    },

    //@TODO - waiting for customer feedback
    trackTrendClick() {
        mixpanel.track(`${source}:trend_clicked`);
    }
};
